import { Badge } from "@/components/ui/badge";
import type { CaseStage } from "@/lib/api";

export function StageBadge({ stage }: { stage: CaseStage }) {
  return <Badge variant={stage === "Approved" ? "success" : "muted"}>{stage}</Badge>;
}
